import * as React from "react";
import { type IconProps, iconProps } from "../util/IconProps";
export function InformationIcon(props: IconProps): React.JSX.Element {
  const { color, size, ...rest } = iconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm.116 7.528c-.32 0-.601-.105-.82-.325-.22-.22-.326-.5-.326-.821 0-.319.105-.597.328-.81.22-.217.499-.322.818-.322.32 0 .599.105.818.323.223.212.328.49.328.809 0 .32-.105.601-.325.82-.22.22-.5.326-.821.326Zm-1.888 7.252a.25.25 0 0 1 .184-.241l.838-.23v-4.08l-.864-.231a.25.25 0 0 1-.186-.242V10a.25.25 0 0 1 .25-.25h2.38a.25.25 0 0 1 .25.25v5.308l.864.23a.25.25 0 0 1 .186.242v.84a.25.25 0 0 1-.25.25h-3.402a.25.25 0 0 1-.25-.25v-.84Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
